<form *ngIf="templateForm" [formGroup]="templateForm" (ngSubmit)="onSubmit(templateForm)" class="content-card">
    <mat-card class="wide-form-card">
        <mat-card-header>
          <mat-card-title>
            <ng-container *ngIf="!isEditingDocName">
              <h5>{{documentName || docName || name }} <mat-icon style="cursor: pointer" (click)="setEditingDocumentName()">edit</mat-icon></h5>
            </ng-container>
            <ng-container *ngIf="isEditingDocName">
              <mat-form-field>
                <input matInput placeholder="Document Name" formControlName="documentName">
              </mat-form-field>
            </ng-container>
          </mat-card-title>
        </mat-card-header>
      <mat-card-content>
        <div style="margin-bottom: 10px; margin-left: 10px;">
          The template will be <b>publicly reachable</b> with this URL: <a target="_blank" href="{{ externalUrlPreview }}">{{ externalUrlPreview }}</a>
        </div>


        <app-html-editor placeholder="Enter message template" formControlName="html" required></app-html-editor>
      </mat-card-content>
      <mat-card-actions align="end">
        <a mat-raised-button color="accent" type="button" routerLink="../..">Cancel</a>
        <button mat-raised-button color="primary" type="submit" [disabled]="!templateForm.valid">Save</button>
      </mat-card-actions>
    </mat-card>
  </form>
